import QRCode from "qrcode";

export default (id, url) => {
    return {
        init: function () {
            QRCode.toCanvas(document.getElementById(id), url, { width: 120 }, function (error) {
                if (error) console.error(error)
            })
        }
    }
}
